import { render, staticRenderFns } from "./AppointmentsCard.vue?vue&type=template&id=4a1833bc&scoped=true&"
import script from "./AppointmentsCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsCard.vue?vue&type=style&index=0&id=4a1833bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1833bc",
  null
  
)

export default component.exports